export function isValidMobileNumber({ value, minLength = 10, maxLength = 11 }) {
  const parsedValue = parseInt(value, 10);
  const mobileStr = String(value);
  if (
    !Number.isNaN(parsedValue) &&
    mobileStr.length >= minLength &&
    mobileStr.length <= maxLength
  ) {
    return true;
  }

  return false;
}
